import {
  Avatar,
  Button,
  Col,
  Collapse,
  Form,
  Input,
  Row,
  Select,
  Skeleton,
  message,
} from "antd";
import BreadCrumb from "../../Components/BreadCrumb/BreadCrumb";
import Layout from "../../Components/Layout/Layout";
import styles from "./CustomerAccount.module.scss";
import CustomerLayout from "../../Components/CustomerLayout/CustomerLayout";
import { useContext, useState } from "react";
import { AuthContext } from "../../Contexts/AuthContext";
import axios from "../../config/axios";

const CustomerAccount = () => {
  const [personalForm] = Form.useForm();
  const [shippingForm] = Form.useForm();
  const { user } = useContext(AuthContext);
  const [dp, setDp] = useState(
    () =>
      user?.dp ||
      "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg"
  );
  const [imageUploadLoading, setImageUploadLoading] = useState(false);
  const [billingUpdateLoading, setBillingUpdateLoading] = useState(false);
  const [shippingUpdateLoading, setShippingUpdateLoading] = useState(false);

  // handle the image upload
  const handleImageUpload = async (e) => {
    const file = e.target?.files[0];
    if (file) {
      // upload the image to the server
      const formData = new FormData();
      formData.append("file", file);
      try {
        setImageUploadLoading(true);
        const response = await axios.post(
          `/admin/fundamentals/upload-file`,
          formData,
          { withCredentials: true }
        );
        setDp(response.data.secure_url);

        // update the user dp
        await axios.patch(
          "/users/update",
          { dp: response.data.secure_url },
          { withCredentials: true }
        );
        message.success("Profile picture updated successfully!");
      } catch (error) {
        message.error("A server side error occurred!");
      } finally {
        setImageUploadLoading(false);
      }
    }
  };

  // update the billing info
  const updateBillingInfo = async (values) => {
    try {
      setBillingUpdateLoading(true);
      await axios.patch("/users/update", values, { withCredentials: true });
      message.success("Billing info updated successfully!");
    } catch (error) {
      message.error("A server side error occurred!");
    } finally {
      setBillingUpdateLoading(false);
    }
  };

  // update the shipping info
  const updateShippingInfo = async (values) => {
    try {
      setShippingUpdateLoading(true);
      await axios.patch("/users/update", values, { withCredentials: true });
      message.success("Shipping info updated successfully!");
    } catch (error) {
      message.error("A server side error occurred!");
    } finally {
      setShippingUpdateLoading(false);
    }
  };

  return (
    <>
      {/* Mobile Version */}
      <Row>
        <Col xs={24} lg={0}>
          <Layout>
            <div className={styles.customer_acc_wrapper}>
              <BreadCrumb
                list={[
                  { name: "Home", link: "/" },
                  {
                    name: "Account Settings",
                    link: "/customer/account",
                  },
                ]}
              />

              <TopAvatar />

              <AccountForms />
            </div>
          </Layout>
        </Col>
      </Row>

      {/* Desktop Version */}
      <Row>
        <Col xs={0} lg={24}>
          <CustomerLayout
            breadcrumb={[
              { name: "Back To Home", link: "/" },
              {
                name: "Account Settings",
                link: `/customer/account`,
              },
            ]}
          >
            <Row>
              <Col span={24}>
                <div className={styles.my_order_dt_top}>
                  <img
                    src="https://desi-fresh.b-cdn.net/components_static/sidebar_icons/setting-active.svg"
                    alt="orders"
                  />
                  <h2>Account Settings</h2>
                </div>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <TopAvatar />
                </div>
              </Col>
            </Row>
            <div
              style={{
                padding: "0 7rem",
              }}
            >
              {/* <AccountForms /> */}
            </div>
          </CustomerLayout>
        </Col>
      </Row>
    </>
  );

  function AccountForms() {
    return (
      <Row>
        <Col span={24}>
          <div
            className={styles.shipping_address_wrapper + " checkout_collapse"}
          >
            <Collapse expandIconPosition={"end"} defaultActiveKey={["1", "2"]}>
              <Collapse.Panel
                key={"1"}
                header={"Personal / Billing Information"}
              >
                <div className={styles.shipping_form}>
                  <Form
                    onFinish={updateBillingInfo}
                    layout="vertical"
                    initialValues={{
                      phone_prefix: "49",
                      country: "germany",
                      ...user,
                    }}
                    requiredMark={false}
                    scrollToFirstError
                    form={personalForm}
                    className={styles.shipping_form_v2}
                  >
                    <Row gutter={[16, 0]}>
                      <Col lg={4} xs={24}>
                        <Form.Item
                          name="b_title"
                          label="Title"
                          style={{
                            maxWidth: "55%",
                          }}
                        >
                          <Select>
                            <Select.Option value="Mr.">Mr.</Select.Option>
                            <Select.Option value="Mrs.">Mrs.</Select.Option>
                            <Select.Option value="Ms.">Ms.</Select.Option>
                            <Select.Option value="Miss.">Miss</Select.Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col lg={10} xs={12}>
                        <Form.Item
                          name="b_first_name"
                          label="First Name*"
                          rules={[
                            {
                              required: true,
                              message: "Please input your first name!",
                            },
                          ]}
                        >
                          <Input placeholder="John" />
                        </Form.Item>
                      </Col>
                      <Col lg={10} xs={12}>
                        <Form.Item
                          name="b_last_name"
                          label="Last Name*"
                          rules={[
                            {
                              required: true,
                              message: "Please input your last name!",
                            },
                          ]}
                        >
                          <Input placeholder="Doe" />
                        </Form.Item>
                      </Col>
                      <Col lg={12} xs={24}>
                        <Form.Item
                          name="b_email"
                          label="Email address*"
                          rules={[
                            {
                              type: "email",
                              message: "The input is not valid email!",
                            },
                            {
                              required: true,
                              message: "Please input your email!",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col lg={12} xs={24}>
                        <Form.Item
                          name="b_phone_number"
                          label="Phone (Optional)"
                        >
                          <Input
                            addonBefore={
                              <Form.Item name="phone_prefix" noStyle>
                                <Select
                                  style={{
                                    width: 70,
                                  }}
                                >
                                  <Select.Option value="49">+49</Select.Option>
                                </Select>
                              </Form.Item>
                            }
                            style={{
                              width: "100%",
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col lg={10} xs={24}>
                        <Form.Item
                          name="b_street_address"
                          label="Street Address*"
                          rules={[
                            {
                              required: true,
                              message: "Please input your street address!",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col lg={6} xs={12}>
                        <Form.Item
                          name="b_house_no"
                          label="House Nr*"
                          rules={[
                            {
                              required: true,
                              message: "Please input your house nr!",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col lg={8} xs={12}>
                        <Form.Item
                          name="b_zip_code"
                          label="Zip / Postal Code*"
                          rules={[
                            {
                              required: true,
                              message: "Please input your zip code",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col lg={8} xs={12}>
                        <Form.Item
                          name="b_city"
                          label="City / Town *"
                          rules={[
                            {
                              required: true,
                              message: "Please input your city name!",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col lg={8} xs={12}>
                        <Form.Item
                          name="b_state"
                          label="State / Region"
                          rules={[
                            {
                              required: false,
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>

                      <Col xs={24}>
                        <Form.Item>
                          <div className={styles.save_btn}>
                            <Button
                              type="primary"
                              htmlType="submit"
                              loading={billingUpdateLoading}
                              disabled={billingUpdateLoading}
                            >
                              Save
                            </Button>
                          </div>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </Collapse.Panel>

              <Collapse.Panel key={"2"} header={"Shipping Information"}>
                <div className={styles.shipping_form}>
                  <Form
                    onFinish={updateShippingInfo}
                    layout="vertical"
                    initialValues={{
                      phone_prefix: "49",
                      country: "germany",
                      ...user,
                    }}
                    requiredMark={false}
                    scrollToFirstError
                    form={shippingForm}
                    className={styles.shipping_form_v2}
                  >
                    <Row gutter={[16, 0]}>
                      <Col lg={4} xs={24}>
                        <Form.Item
                          name="s_title"
                          label="Title"
                          style={{
                            maxWidth: "55%",
                          }}
                        >
                          <Select>
                            <Select.Option value="Mr.">Mr.</Select.Option>
                            <Select.Option value="Mrs.">Mrs.</Select.Option>
                            <Select.Option value="Ms.">Ms.</Select.Option>
                            <Select.Option value="Miss.">Miss</Select.Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col lg={10} xs={12}>
                        <Form.Item
                          name="s_first_name"
                          label="First Name*"
                          rules={[
                            {
                              required: true,
                              message: "Please input your first name!",
                            },
                          ]}
                        >
                          <Input placeholder="John" />
                        </Form.Item>
                      </Col>
                      <Col lg={10} xs={12}>
                        <Form.Item
                          name="s_last_name"
                          label="Last Name*"
                          rules={[
                            {
                              required: true,
                              message: "Please input your last name!",
                            },
                          ]}
                        >
                          <Input placeholder="Doe" />
                        </Form.Item>
                      </Col>
                      <Col lg={12} xs={24}>
                        <Form.Item
                          name="s_email"
                          label="Email address*"
                          rules={[
                            {
                              type: "email",
                              message: "The input is not valid email!",
                            },
                            {
                              required: true,
                              message: "Please input your email!",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col lg={12} xs={24}>
                        <Form.Item
                          name="s_phone_number"
                          label="Phone (Optional)"
                        >
                          <Input
                            addonBefore={
                              <Form.Item name="phone_prefix" noStyle>
                                <Select
                                  style={{
                                    width: 70,
                                  }}
                                >
                                  <Select.Option value="49">+49</Select.Option>
                                </Select>
                              </Form.Item>
                            }
                            style={{
                              width: "100%",
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col lg={10} xs={24}>
                        <Form.Item
                          name="s_street_address"
                          label="Street Address*"
                          rules={[
                            {
                              required: true,
                              message: "Please input your street address!",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col lg={6} xs={12}>
                        <Form.Item
                          name="s_house_no"
                          label="House Nr*"
                          rules={[
                            {
                              required: true,
                              message: "Please input your house nr!",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col lg={8} xs={12}>
                        <Form.Item
                          name="s_zip_code"
                          label="Zip / Postal Code*"
                          rules={[
                            {
                              required: true,
                              message: "Please input your zip code",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col lg={8} xs={12}>
                        <Form.Item
                          name="s_city"
                          label="City / Town *"
                          rules={[
                            {
                              required: true,
                              message: "Please input your city name!",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col lg={8} xs={12}>
                        <Form.Item
                          name="s_state"
                          label="State / Region"
                          rules={[
                            {
                              required: false,
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>

                      <Col xs={24}>
                        <Form.Item>
                          <div className={styles.save_btn}>
                            <Button
                              type="primary"
                              htmlType="submit"
                              loading={shippingUpdateLoading}
                              disabled={shippingUpdateLoading}
                            >
                              Save
                            </Button>
                          </div>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </Collapse.Panel>
            </Collapse>
          </div>
        </Col>
      </Row>
    );
  }

  function TopAvatar() {
    return (
      <div className={styles.setting_top}>
        <h2>Account settings</h2>
        <div className={styles.acc_avatar}>
          {imageUploadLoading ? (
            <Skeleton.Avatar active size={90} shape="circle" />
          ) : (
            <Avatar src={dp} size={90} />
          )}

          <input
            onChange={handleImageUpload}
            data-file-auto-upload="1"
            data-file-extensions="png,gif,jpg,jpeg"
            accept="image/*,capture=camera"
            type="file"
            id="dp"
            className="d-none"
            name="dp"
          />
          <label htmlFor="dp" className={styles.nok_img_upload}>
            <img
              src="https://desi-fresh.b-cdn.net/components_static/Account/edit.svg"
              alt="edit"
              className={styles.edit_icon}
            />
          </label>
        </div>
      </div>
    );
  }
};

export default CustomerAccount;
